import { ReactNode } from 'react'

import { useTranslation } from 'react-i18next'
import { CurecallButton, CurecallTooltip, ECurecallSize, EyeIcon, PenIcon } from '@honestica/curecall-ui'
import { EContentType, TContent } from './content.type'
import { twMerge } from 'src/utils/tw-merge.util'
import { getContentExtract, getFirstContentFromContent } from './content-list.util'

const TextCell = ({ children }: { children: ReactNode }) => (
  <p className="c-font-nexa c-text-xs c-m-0">{children}</p>
)

const ContentCell = ({ content }: { content: TContent }) => {
  return (
    <p
      className={twMerge(
        'c-font-nexa c-text-xs c-m-0 c-max-h-12 c-text-ellipsis c-overflow-hidden c-block c-w-96 c-whitespace-nowrap',
        content.type === 'external-link' && 'c-text-primary c-underline',
      )}
    >
      {getContentExtract(content)}
    </p>
  )
}

const ActionsCell = ({
  content,
  setContentToShow,
  onUpdateContent,
}: {
  content: TContent
  setContentToShow: (content: TContent) => void
  onUpdateContent: (id: number) => void
}) => {
  const { t } = useTranslation()

  const nonPreviewableDomains = ['search.google.com', 'www.youtube.com']
  const isPreviewAvailable = !(
    content.type === EContentType.EXTERNAL_LINK &&
    nonPreviewableDomains.some((domain) => getFirstContentFromContent(content).includes(domain))
  )

  return (
    <div className="c-flex c-justify-end c-gap-2 c-items-center c-w-full">
      {isPreviewAvailable ? (
        <CurecallButton
          isGhostButton={true}
          ariaLabelText={t('pages.configuration.contents.preview')}
          iconType={<EyeIcon className="c-w-5" />}
          onClick={() => setContentToShow(content)}
          size={ECurecallSize.SMALL}
          className="tw-text-primary [&>div]:c-w-5 [&>div]:c-h-5"
        />
      ) : (
        <CurecallTooltip
          content={t('pages.configuration.contents.non-previewable-domain')}
          tooltipPosition="left"
        >
          <CurecallButton
            isGhostButton={true}
            ariaLabelText={t('pages.configuration.contents.preview')}
            iconType={<EyeIcon className="c-w-5" />}
            size={ECurecallSize.SMALL}
            className="[&>div]:c-w-5 [&>div]:c-h-5"
            isDisabled={true}
            disabled={true}
          />
        </CurecallTooltip>
      )}

      <CurecallButton
        isGhostButton={true}
        ariaLabelText={t('pages.configuration.contents.update-content-name', {
          name: content.name,
        })}
        iconType={<PenIcon />}
        onClick={() => onUpdateContent(content.id)}
        size={ECurecallSize.SMALL}
        className="tw-text-primary"
      />
    </div>
  )
}

export { TextCell, ContentCell, ActionsCell }
